import React from "react";

const Text = ({ text, styleText }) => {
  return <div className={styleText}>{text}</div>;
};

export default Text;
